export enum DiscountMethod {
  Number = "Number",
  Percentage = "Percentage",
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-models/DiscountMethod.ts